export function getToken(state: any) {
	return state.auth.token;
}
